/**
 * @fileoverview
 * This file contains functions to hide and show elements from screen readers
 * when the modal is open and closed.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/inert
 * @see https://www.w3.org/TR/wai-aria-1.1/#aria-modal
 */
const WRAPPER_ID = 'app'

/**
 * Prevent screen readers from reading content outside the modal
 */
export const hideFromScreenReaders = () => {
	if (document) {
		const wrapper = document.getElementById(WRAPPER_ID)
		if (wrapper) {
			wrapper.setAttribute('inert', '')
		}
	}
}

/**
 * Restore screen readers reading content outside the modal when it is closed
 */
export const restoreForScreenReaders = () => {
	const wrapper = document.getElementById(WRAPPER_ID)
	if (wrapper) {
		wrapper.removeAttribute('inert')
	}
}
